<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <img src="/assets/img/logo.png"/>
        <div class="card">
          <div class="card-body p-4">
            <h1>Register</h1>
            <span style="color: red">{{errorMessage}}</span>
            <span style="color: green">{{infoMessage}}</span>
            <p class="text-muted">
              Create your account. By creating your account you agree to our
              <a href="https://www.extrawatch.com/terms-and-conditions" target="_blank">Terms and conditions</a>
              and <a href="https://www.extrawatch.com/privacy-policy" target="_blank">Privacy policy</a>.
            </p>

            <br/>
            <br/>

            <div class="input-group mb-3">
              <span class="input-group-addon">&#64;</span>
              <input type="text" class="form-control" placeholder="Email" [(ngModel)]="email">
            </div>

            <div class="input-group mb-3">
              <span class="input-group-addon"><i class="icon-lock"></i></span>
              <input type="password" class="form-control" placeholder="Password" [(ngModel)]="password">
            </div>

            <div class="input-group mb-4">
              <span class="input-group-addon"><i class="icon-lock"></i></span>
              <input type="password" class="form-control" placeholder="Repeat password" [(ngModel)]="repeatPassword">
            </div>

            <button type="button" class="btn btn-block btn-success" (click)="createAccount()">Create Account</button>

            <br/>
            <button type="button" class="btn btn-link px-0" onclick="history.go(-1)">&lt; Back</button>
          </div>
          <div class="card-footer p-4">
            <div class="row">
              <div class="col-6">
                <a href="https://www.facebook.com/ExtraWatch/" target="_blank">
                  <button class="btn btn-block btn-facebook" type="button"><span>facebook</span></button>
                </a>
              </div>
              <div class="col-6">
                <a href="https://twitter.com/extrawatch" target="_blank">
                  <button class="btn btn-block btn-twitter" type="button"><span>twitter</span></button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
